import { Box } from '@mantine/core';
import { ComponentType, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { WidgetType } from 'shared/common/utils/widgetsUtils';
import { Tabs } from 'shared/components/layouts/Tabs';

import { ConfigTitle } from '../ConfigTitle';

export type WidgetConfigProps = {
  children: ReactNode;
  tabs: string[];
  customTitle?: ReactNode;
  title?: string;
  Icon?: ComponentType<{ width: number; height: number }> | string;
  type?: WidgetType;
  keepTabsMounted?: boolean;
};

export function WidgetConfig(props: WidgetConfigProps) {
  const { children, tabs: tabValues, type, title, Icon, customTitle, keepTabsMounted } = props;
  const { t } = useTranslation('widgets');

  const tabs = tabValues.map(tab => {
    return {
      value: tab,
      text: t(`widgetConfig.${tab}`)
    };
  });

  return (
    <Box>
      {customTitle ? (
        customTitle
      ) : type === WidgetType.Plugin || type === WidgetType.EvaluatablePlugin ? (
        <ConfigTitle title={title} Icon={Icon} />
      ) : (
        <ConfigTitle />
      )}
      <Tabs tabs={tabs} keepTabsMounted={keepTabsMounted}>
        {children}
      </Tabs>
    </Box>
  );
}
